import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import client from '../api/client';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await client.post('/auth/login', { email, password });
      localStorage.setItem('token', res.data.access_token);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleAddBookmark = () => {
    const url = window.location.origin;
    const title = '都行嘛网络加速器';
    
    if ((window as any).sidebar && (window as any).sidebar.addPanel) {
      (window as any).sidebar.addPanel(title, url, '');
    } else if ((window as any).external && ('AddFavorite' in (window as any).external)) {
      (window as any).external.AddFavorite(url, title);
    } else {
      alert(
        language === 'zh' 
          ? `请按 Ctrl+D (Windows) 或 Cmd+D (Mac) 将本站加入收藏夹\n\n网址：${url}`
          : `Please press Ctrl+D (Windows) or Cmd+D (Mac) to bookmark this site\n\nURL: ${url}`
      );
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 1000 }}>
        <LanguageSwitcher />
      </div>
      
      <div style={styles.contentWrapper}>
        <div style={styles.card}>
        
        <div style={styles.header}>
          <h1 style={styles.brand}>{t.brand}</h1>
          <p style={styles.slogan}>{t.slogan}</p>
          <p style={styles.tagline}>{t.tagline}</p>
          <p style={styles.domain}>{t.domain}</p>
        </div>
        
        <h2 style={styles.title}>{t.loginTitle}</h2>
        <p style={styles.subtitle}>{t.loginSubtitle}</p>
        
        {/* 为什么选择我们 */}
        <div style={{ background: '#f0f7ff', border: '1px solid #91caff', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
          <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#0958d9', marginBottom: '10px', marginTop: 0 }}>为什么不选便宜机场，选我们？</h4>
          <div style={{ fontSize: '12px', lineHeight: '1.6', color: '#333' }}>
            <p style={{ margin: '0 0 8px 0' }}><strong>便宜机场的套路：</strong>年付/终身套餐 → 用几个月 → 跑路了。<strong>我们只卖月付，不打算跑路。</strong></p>
            <p style={{ margin: '0 0 8px 0' }}><strong>AWS 海外服务器</strong>，不存在"被国内机房一锅端"的风险。</p>
            <p style={{ margin: '0 0 8px 0' }}><strong>每个 IP 只服务 30 人</strong>，流量特征分散，更难被封锁。</p>
            <p style={{ margin: '0 0 8px 0' }}><strong>Hysteria2 + 跳频</strong>，抗封锁能力最强，自动切换持续可用。</p>
            <p style={{ margin: '0 0 8px 0' }}><strong>前 Google/Amazon/微软工程师</strong>，肉身在美国，响应快。</p>
            <p style={{ margin: '0', padding: '10px', background: '#fff', borderRadius: '4px', border: '1px solid #91caff' }}><strong>免费试用 3天/1GB</strong>，月付 ¥29，随时可以不续。</p>
          </div>
        </div>
        
        <div style={styles.promoBox}>
          {t.loginPromo}
        </div>

        {/* 安卓官方 App：登录即用，无需导入订阅链接 */}
        <div style={{ background: '#EEF0FF', border: '1px solid #C7CBFF', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: 700, color: '#4338CA' }}>安卓用户推荐：都行啊 App</p>
          <p style={{ margin: '0 0 10px 0', fontSize: '12px', lineHeight: '1.6', color: '#333' }}>
            安装后用本站账号登录，点一下即可连接，无需复制订阅链接、无需安装第三方客户端。
          </p>
          <a
            href="/downloads/douxingma-1.0.0-arm64.apk"
            style={{ display: 'inline-block', padding: '8px 16px', borderRadius: '6px', background: 'linear-gradient(135deg, #5B5FEF, #4338CA)', color: '#fff', fontSize: '13px', fontWeight: 700, textDecoration: 'none' }}
          >
            下载安卓 App（1.0.0）
          </a>
        </div>
        
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="email"
            placeholder={t.email}
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder={t.password}
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? t.loggingIn : t.loginButton}
          </button>
        </form>
        <p style={styles.forgotPassword}>
          <Link to="/forgot-password" style={styles.linkText}>
            {language === 'zh' ? '忘记密码？' : 'Forgot password?'}
          </Link>
        </p>
        <p style={styles.link}>
          {t.noAccount}<Link to="/register" style={styles.linkText}>{t.registerNow}</Link>
        </p>
        
        <div style={styles.legalLinks}>
          <a href="/user-agreement" style={styles.legalLink}>{t.userAgreement}</a>
          <span style={styles.linkSeparator}>|</span>
          <a href="/privacy-policy" style={styles.legalLink}>{t.privacyPolicy}</a>
          <span style={styles.linkSeparator}>|</span>
          <a href="/terms-of-service" style={styles.legalLink}>{t.termsOfService}</a>
        </div>

        <a
          href="https://x.com/douxingma82248"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.xLink}
        >
          𝕏 @douxingma82248 &nbsp;·&nbsp; {language === 'zh' ? '私信反馈异常可领 7天 + 30GB' : 'DM to report issues → 7 days + 30 GB reward'}
        </a>
      </div>
    </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    minHeight: '100vh', 
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '420px',
  },
  card: {
    background: '#fff', 
    padding: '48px 40px', 
    borderRadius: '16px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)', 
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
    paddingBottom: '24px',
    borderBottom: '2px solid #f0f0f0',
  },
  brand: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#667eea',
    margin: '0 0 8px 0',
  },
  slogan: {
    fontSize: '14px',
    color: '#888',
    margin: '0 0 4px 0',
  },
  tagline: {
    fontSize: '13px',
    color: '#667eea',
    margin: '0 0 8px 0',
    fontWeight: '500',
  },
  domain: {
    fontSize: '13px',
    color: '#667eea',
    margin: 0,
    fontWeight: '500',
  },
  title: { 
    textAlign: 'center', 
    marginBottom: '8px', 
    color: '#333',
    fontSize: '24px',
    fontWeight: '600',
  },
  subtitle: {
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
    marginBottom: '20px',
  },
  promoBox: {
    textAlign: 'center',
    padding: '12px',
    background: 'linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%)',
    border: '2px solid #91d5ff',
    borderRadius: '8px',
    color: '#0050b3',
    fontSize: '14px',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  input: {
    width: '100%', 
    padding: '14px 16px', 
    marginBottom: '16px',
    border: '2px solid #e8e8e8', 
    borderRadius: '8px', 
    fontSize: '15px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s',
    outline: 'none',
  },
  button: {
    width: '100%', 
    padding: '14px', 
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff', 
    border: 'none', 
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
  },
  error: { 
    color: '#ff4d4f', 
    textAlign: 'center', 
    marginBottom: '16px',
    padding: '12px',
    background: '#fff2f0',
    borderRadius: '8px',
    fontSize: '14px',
  },
  link: { 
    textAlign: 'center', 
    marginTop: '24px', 
    fontSize: '14px',
    color: '#666',
  },
  forgotPassword: {
    textAlign: 'center',
    marginTop: '12px',
    fontSize: '14px',
    color: '#666',
  },
  linkText: {
    color: '#667eea',
    textDecoration: 'none',
    fontWeight: '600',
    marginLeft: '4px',
  },
  bookmarkBtn: {
    width: '100%',
    padding: '12px',
    marginTop: '16px',
    background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
    color: '#333',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 2px 8px rgba(255, 215, 0, 0.3)',
  },
  legalLinks: {
    marginTop: '24px',
    paddingTop: '20px',
    borderTop: '1px solid #f0f0f0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap'
  },
  legalLink: {
    color: '#999',
    textDecoration: 'none',
    fontSize: '12px',
    transition: 'color 0.2s'
  },
  linkSeparator: {
    color: '#ddd',
    fontSize: '12px'
  },
  xLink: {
    display: 'block',
    marginTop: '16px',
    textAlign: 'center',
    color: '#555',
    textDecoration: 'none',
    fontSize: '13px',
    fontWeight: '600',
    padding: '8px',
    borderRadius: '6px',
    background: '#f5f5f5',
    transition: 'background 0.2s',
  }
};